import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AccountProfileCommunicationsModule } from 'AccountsApp/ts/apps/account-profile-communications-app/app.module';
import { FeatureNeededModule } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.module';
import * as i0 from "@angular/core";
export class PerformanceIncludeBenchmarkCheckboxModule {
}
PerformanceIncludeBenchmarkCheckboxModule.ɵfac = function PerformanceIncludeBenchmarkCheckboxModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PerformanceIncludeBenchmarkCheckboxModule)(); };
PerformanceIncludeBenchmarkCheckboxModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PerformanceIncludeBenchmarkCheckboxModule });
PerformanceIncludeBenchmarkCheckboxModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [AccountProfileCommunicationsModule, CommonModule, FeatureNeededModule, FormsModule] });
